/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_REGISTRY, getDefaultFormState } from '../../../utils/defaults';
import { isFixedItems, getSchemaTypeI18nKey } from '../../../utils/typeUtils';
import { isFilesArray, isMultiSelect } from '../../../utils/fieldTypes';
import { getParamRowId } from '../../../utils/idUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import UnderConstruction from '../../../../Doc/components/UnderConstruction';
import DescriptionField from '../DescriptionField';
import UnsupportedField from '../UnsupportedField';
import ArrayFieldItems from './ArrayFieldItems';
import AddButton from '../shared/AddButton';
import DescriptorBlock from '../shared/DescriptorBlock';

// Template component for standard array items
/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DefaultNormalArrayFieldTemplate(props) {
  const {
    disabled,
    formData,
    idSchema,
    items: fieldItems,
    itemsAreObjectType,
    readOnly,
    registry = DEFAULT_REGISTRY,
    required,
    schema,
    schemaGroup,
    title,
    canAddItem,
    onAddItemClick
  } = props;
  const {
    description
  } = schema;
  const {
    definitions
  } = registry;
  const typeI18nKey = getSchemaTypeI18nKey(schema, definitions);
  return /*#__PURE__*/_jsxs("div", {
    className: "params-row",
    "data-test-id": `schema-field-${getParamRowId(idSchema.$id)}`,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "params-pair",
      children: [/*#__PURE__*/_jsx(DescriptorBlock
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        description: description,
        id: idSchema.$id,
        label: title,
        required: required,
        schema: schema,
        schemaGroup: schemaGroup,
        schemaTypeI18nKey: typeI18nKey
      }), /*#__PURE__*/_jsxs("div", {
        className: "params-content",
        children: [description && /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(DescriptionField
          /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
            description: description,
            id: `${idSchema.$id}-description`
          })
        }), !itemsAreObjectType && fieldItems, itemsAreObjectType && canAddItem(formData) &&
        /*#__PURE__*/
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        _jsx(AddButton, {
          onClick: onAddItemClick,
          disabled: disabled || readOnly,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.params.body.addTestValue"
          })
        })]
      })]
    }), itemsAreObjectType && fieldItems]
  });
}
export default class ArrayField extends Component {
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  constructor(props) {
    super(props);
    this.onAddItemClick = () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        formData,
        registry,
        schema
      } = this.props;
      const {
        definitions
      } = registry;
      this.setState({
        modified: true
      });
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.props.onChange([...formData, getDefaultFormState(schema.items, undefined, definitions)]);
    };
    this.onRemoveItemClick = index => () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        formData,
        onChange
      } = this.props;
      // remove the matching formData entry
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const newFormData = formData.filter((__, i) => i !== index);
      this.setState({
        modified: true
      }, () => onChange(newFormData));
    };
    this.onChangeForIndex = index => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      return (value, errorSchema) => {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        const {
          formData,
          onChange
        } = this.props;
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        const newFormData = formData.map((item, i) => {
          // We need to treat undefined items as nulls to have validation.
          // See https://github.com/tdegrunt/jsonschema/issues/206
          const jsonValue = typeof value === 'undefined' ? null : value;
          return index === i ? jsonValue : item;
        });
        onChange(newFormData, errorSchema && /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.props.errorSchema && Object.assign({}, this.props.errorSchema, {
          [index]: errorSchema
        }));
      };
    };
    this.canAddItem = formItems => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        schema
      } = this.props;
      if (schema.maxItems !== undefined) {
        return formItems.length < schema.maxItems;
      } else if (schema.items.oneOf || schema.items.anyOf) {
        return false;
      } else {
        return true;
      }
    };
    this.canRemoveItem = formItems => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        required,
        schema
      } = this.props;
      if (!(formItems && formItems.length)) {
        return false;
      }
      if (required && formItems.length <= 1) {
        return false;
      }
      if (schema.minItems !== undefined) {
        return formItems.length > schema.minItems;
      }
      return true;
    };
    this.state = {
      modified: false
    };
  }

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  renderNormalArray() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errorSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idPrefix,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      name,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry = DEFAULT_REGISTRY,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schemaGroup
    } = this.props;
    const {
      definitions
    } = registry;
    const title = schema.title === undefined ? name : schema.title;
    const itemsAreObjectType = !!schema.items.type && schema.items.type === 'object' || !!schema.items.$ref;
    const fieldItems = /*#__PURE__*/_jsx(ArrayFieldItems
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
      autoFocus: this.state.modified,
      canAddItem: this.canAddItem,
      canRemoveItem: this.canRemoveItem,
      definitions: definitions,
      disabled: disabled,
      errorSchema: errorSchema,
      formData: formData,
      idPrefix: idPrefix,
      idSchema: idSchema,
      onAddItemClick: this.onAddItemClick,
      onChangeForIndex: this.onChangeForIndex,
      onRemoveItemClick: this.onRemoveItemClick,
      readOnly: readOnly,
      registry: registry,
      schema: schema,
      showAddButton: !itemsAreObjectType
    });

    // Standard prop shape for each array template component
    const arrayProps = {
      canAddItem: this.canAddItem,
      DescriptionField,
      disabled,
      formData,
      idSchema,
      items: fieldItems,
      itemsAreObjectType,
      onAddItemClick: this.onAddItemClick,
      readOnly,
      registry,
      required,
      schema,
      schemaGroup,
      title
    };

    // Support multiple template types in the future
    const TemplateComponent = DefaultNormalArrayFieldTemplate;
    return /*#__PURE__*/_jsx(TemplateComponent, Object.assign({}, arrayProps));
  }
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      idSchema,
      registry,
      schema
    } = this.props;
    const {
      definitions
    } = registry;
    if (!schema.hasOwnProperty('items')) {
      return /*#__PURE__*/_jsx(UnsupportedField
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        idSchema: idSchema,
        reason: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.errors.arrayHasNoItems"
        })
      });
    } else if (isFixedItems(schema)) {
      return /*#__PURE__*/_jsx(UnderConstruction, {
        component: "Fixed items array"
      });
    } else if (isFilesArray(schema, definitions)) {
      return /*#__PURE__*/_jsx(UnderConstruction, {
        component: "Files array"
      });
    } else if (isMultiSelect(schema, definitions)) {
      return /*#__PURE__*/_jsx(UnderConstruction, {
        component: "Multiselect array"
      });
    }
    return this.renderNormalArray();
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ArrayField.propTypes = {
  disabled: PropTypes.bool,
  errorSchema: PropTypes.object,
  formData: PropTypes.array,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string
};

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ArrayField.defaultProps = {
  disabled: false,
  formData: [],
  idSchema: {},
  readOnly: false
};